import React from 'react';
import { Wrench, Gauge, CircleDot, Settings, ClipboardCheck, Cog, Target, Lightbulb, Wind, Battery, Check } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Wrench,
  Gauge,
  CircleDot,
  Settings,
  ClipboardCheck,
  Cog,
  Target,
  Lightbulb,
  Wind,
  Battery
};

const DetailedServices = () => {
  return (
    <section className="py-20 bg-slate-100">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-slate-200 text-slate-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Services Détaillés
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Notre Expertise
            <span className="block text-sky-600 mt-2">en Détail</span>
          </h2>
        </div>

        {/* Detailed Services List */}
        <div className="space-y-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            const isEven = index % 2 === 0;
            
            return (
              <div
                key={service.id}
                className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 lg:gap-12 items-center bg-gradient-to-br from-slate-200 to-slate-100 rounded-2xl p-8 lg:p-12 hover:shadow-xl transition-shadow border border-slate-300 shadow-md`}
              >
                {/* Icon & Title */}
                <div className="lg:w-1/3">
                  <div className="bg-gradient-to-br from-sky-500 to-slate-600 w-20 h-20 rounded-2xl flex items-center justify-center mb-4">
                    <IconComponent className="text-white" size={40} />
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-sky-600 font-semibold">{service.description}</p>
                </div>

                {/* Details */}
                <div className="lg:w-2/3">
                  <p className="text-slate-700 text-lg leading-relaxed">
                    {service.details}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DetailedServices;
